'use strict'

define [], () ->
  ($scope, $rootScope, $uibModalInstance, ApplicationTemplate, $cacheFactory) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    
    $scope.remove_apptemp = (id) ->
      ApplicationTemplate.remove(id: id).$promise.then ->
        $cacheFactory.get("$http").removeAll()
        $uibModalInstance.close()
        $rootScope.$broadcast("forms-changed")



// WEBPACK FOOTER //
// ./directives/apptemplatesTable/removeModal.coffee